import { ModelElement, ModelWriter } from 'ckeditor5';

export const removeContentBeforeSectionHeading = (writer: ModelWriter) => {
  const { document } = writer.model;
  const root = document.getRoot('main');
  let hasModifiedContent = false;
  if (root) {
    // check if there are two section headings without any content in between
    for (const child of root.getChildren()) {
      const element = child as ModelElement;
      if (element.name === 'sectionHeading') {
        let focusedElement = element.previousSibling;
        while (focusedElement) {
          hasModifiedContent = true;
          writer.remove(focusedElement);
          focusedElement = focusedElement.previousSibling;
        }
        return hasModifiedContent;
      }
    }
  }
  return false;
};
